export default __webpack_public_path__ + "static/backend-per-iot-aefb6c48eadc7aafd9c98ee0cdf65d79.jpg";